/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Esito dell\'importazione di una domanda esercente da un altro bando
 */
export enum EsitoImportazioneEsercente {

    CREATA = 'CREATA',

    SALTATA = 'SALTATA',

    ERRORE = 'ERRORE'
}

